import {useCallback, useMemo, useState} from "react";
import {
	SelectField,
	DateField
} from "~/components/Forms";
import {strToTime} from "../../../../../utils";

function CommitSearchBar({filter, listGroup, onChange}) {

	const [optionsGroupType, setOptionsGroupType] = useState([
		{ value: 'group' , label:'Xem theo nhóm' },
		{ value: 'tree' , label:'Xem theo nhánh' }
	]);

	const groupOptions = useMemo(() => {
		return [{ value: '', label: 'Tất các nhóm' }, ...Object.entries(listGroup).map(([key, group]) => {
			return {
				value: group.id,
				label: group.name
			};
		})];
	}, [listGroup]);

	const handleGroupTypeChange = useCallback((value) => {
		if(onChange) onChange('groupType', value);
	}, [onChange]);

	const handleGroupChange = useCallback((value) => {
		if(onChange) onChange('groupId', value);
	}, [onChange]);

	const handleTimeChange = useCallback((value) => {
		value = strToTime(value);
		if(onChange) onChange('time', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<DateField placeholder="Chọn ngày cam kết" onChange={(value, event) => handleTimeChange(value)} value={filter.time*1000} />
					<SelectField placeholder="Chọn loại lọc" options={optionsGroupType} onChange={(value, event) => handleGroupTypeChange(value)} />
					<SelectField placeholder="Chọn nhóm" options={groupOptions} onChange={(value, event) => handleGroupChange(value)} />
				</form>
			</div>
		</div>
	)
}

export default CommitSearchBar;